export default "__VITE_ASSET__CfC2hBuV__"